import React, { Component } from 'react'
import { Button, Form, Table, Input, message, Row, Col } from 'antd'

import { getTraverList } from '_src/api/api'

import { getCardTypeName } from '_src/utils/tool'

import exportExcel from '_src/utils/exportExcel'
import moment from 'moment'

const { Search } = Input
class Special extends Component {
  constructor (props) {
    super(props)
    this.firstLoad = true // 是否第一次加载
    this.loading = true
    this.param = {
      passengerName: ''
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      dataList: [],
      excelList: [],
    
    }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    const { record: {groupDate, id} } = this.props
    const { passengerName } = this.param
    let param = null
    if (passengerName) {
      param = { passengerName }
    }
    // const { status, pageNum } = this.param 
    getTraverList(groupDate, id, param)
      .then(res=>{
        this.loading = false
        const { data } = res
        const dataList = data.map((item, index)=>{
          return {index: (index+1), ...item, key: index, cardType: getCardTypeName(item.cardType) }
        })
        this.setState(()=>({
          dataList: dataList,
          visible: false
        }))
        if (this.firstLoad) {
          this.firstLoad = false
          this.setState(()=>({
            excelList: dataList
          }))
        }
      })
  }
  columns = () => {
    return [
      {
        title: '排序',
        align: 'center',
        dataIndex: 'index',
        key: 'index',
      },
      {
        title: '订单号',
        align: 'center',
        dataIndex: 'orderSn',
        key: 'orderSn',
        
      },
      {
        title: '旅客姓名',
        align: 'center',
        dataIndex: 'name',
        key: 'name',
      },
      // {
      //   title: <span>专题数量</span>,
      //   align: 'center',
      //   dataIndex: 'link',
      //   render: item => <a href={item} target='_blank'>{item}</a>
      // },
      {
        title: '证件类型',
        align: 'center',
        dataIndex: 'cardType',
        key: 'cardType',
        // render: type => <span>{getCardTypeName(type)}</span>
      },
     
      {
        title: '证件号',
        align: 'center',
        dataIndex: 'cardNumber',
        key: 'cardNumber',
      },
      {
        title: '价格',
        align: 'center',
        dataIndex: 'money',
        key: 'money',
      }
    ]
  }

 
  handleSearch = (key, v) => {
    this.param[key] = v
    this.loadData()
  }

  handleExcel = () => {
    const { excelList } = this.state
    let now = moment().format('YYYY-MM-DD')
    if (!!excelList.length) {
      exportExcel(this.columns(), excelList, `参团人数订单${now}`) 
    }
    else {
      message.error('没有需要导出的数据', 1.5)
    }
  }

  render () {
    const { dataList } = this.state
   
    return (
      <div className = "Special">
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "旅客姓名" >
                  <Search placeholder="请输入旅客姓名" onSearch={(v)=>{ this.handleSearch('passengerName', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {16}>
                <Form.Item style = {{float: 'right'}}>
                  <Button type = "primary" icon="download" onClick = { this.handleExcel }>导出</Button>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {this.loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
        />
      </div>
    )
  }
}

export default Special